import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowLeft, ArrowRight } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";
import { PREQUAL } from "@/constants/testIds";

export const ProgressBar = ({ step, total, currentLabel }) => {
  const pct = ((step + 1) / total) * 100;
  return (
    <>
      <div className="flex items-center justify-between mb-2">
        <div className="eyebrow text-razmek-gray">
          Paso {step + 1} de {total}
        </div>
        <div className="eyebrow text-razmek-gold">{currentLabel}</div>
      </div>
      <div className="h-[2px] bg-razmek/30 mb-10 relative">
        <motion.div
          className="absolute inset-y-0 left-0 bg-razmek-gold"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.4 }}
        />
      </div>
    </>
  );
};

export const NavButtons = ({
  step,
  totalSteps,
  canGoNext,
  submitting,
  onPrev,
  onNext,
  onSubmit,
}) => {
  const isLast = step >= totalSteps - 1;
  return (
    <div className="mt-12 flex items-center justify-between">
      <Button
        variant="ghost"
        disabled={step === 0}
        onClick={onPrev}
        data-testid={PREQUAL.prev}
        className="rounded-none text-razmek-dark hover:text-razmek-blue font-sans tracking-[0.14em] uppercase text-[11px]"
      >
        <ArrowLeft size={14} className="mr-2" /> Atrás
      </Button>
      {!isLast ? (
        <Button
          onClick={onNext}
          disabled={!canGoNext}
          data-testid={PREQUAL.next}
          className="bg-razmek-blue hover:bg-razmek-dark text-white rounded-none border-2 border-razmek-blue hover:border-razmek-gold font-sans tracking-[0.14em] uppercase text-[11px] px-6 py-5"
        >
          Continuar <ArrowRight size={14} className="ml-2" />
        </Button>
      ) : (
        <Button
          onClick={onSubmit}
          disabled={!canGoNext || submitting}
          data-testid={PREQUAL.submit}
          className="bg-razmek-gold hover:bg-razmek-dark text-white rounded-none border-2 border-razmek-gold hover:border-razmek-gold font-sans tracking-[0.14em] uppercase text-[11px] px-6 py-5"
        >
          {submitting ? "Enviando…" : "Enviar diagnóstico"}
        </Button>
      )}
    </div>
  );
};

export const SuccessScreen = ({ proteccion }) => {
  const cat = CATEGORIES.find((c) => c.slug === proteccion);
  return (
    <div className="text-center py-16">
      <CheckCircle2 size={56} className="text-razmek-gold mx-auto" />
      <h2 className="font-serif text-4xl mt-6 text-razmek-dark">
        Diagnóstico recibido
      </h2>
      <p className="font-sans text-base text-razmek-dark/70 mt-4 max-w-md mx-auto leading-relaxed">
        Hemos preparado tu resumen. Un asesor patrimonial revisará tu caso y te
        contactará en menos de 24 horas hábiles.
      </p>
      {cat && (
        <div className="mt-12 max-w-md mx-auto border border-razmek p-8 text-left">
          <div className="eyebrow text-razmek-gold">Categoría sugerida</div>
          <div className="font-serif text-2xl text-razmek-dark mt-2">
            {cat.label}
          </div>
          <p className="font-sans text-sm text-razmek-dark/60 mt-2">{cat.short}</p>
        </div>
      )}
    </div>
  );
};
